/**
 * Which panel of the old right-hand sidebar a user last had open.
 *
 * The sidebar itself is gone — the dock replaced it — but the setting outlived
 * it: it is stored per user and read when the settings come in, so the values
 * have to keep their meaning even though nothing renders them any more.
 */
export enum SidebarPanels {
    ContactDetails = 0,
    InvoiceDetails = 1,
    Activities = 2,
    Transitions = 3,
    InternalNotes = 4,
}
